import { z } from "zod";
import { zUid } from "./zUid";
import { zDisplayId } from "./ZDisplayId";

export const zObjState = z.object({
  id: zUid,
  displayId: zDisplayId.nullish(),
  name: z.string(),
  objectId: zUid.nullable(),
});

export type ZObjState = z.infer<typeof zObjState>;
